import { Component, OnInit, Input, OnDestroy } from '@angular/core';

import { SwiperConfigInterface } from 'ngx-swiper-wrapper';

import { MediaMatcher } from '@angular/cdk/layout';

@Component({
  selector: 'unh-project-highlight',
  templateUrl: './project-highlight.component.html',
  styleUrls: ['./project-highlight.component.scss']
})
export class ProjectHighlightComponent implements OnInit, OnDestroy {
  private query: MediaQueryList;

  public config: SwiperConfigInterface = {};
  public isSmallMobile = true;

  @Input() projects: any;

  constructor(private media: MediaMatcher) {}

  ngOnInit(): void {
    this.observeMediaQuery();

    this.config = {
      a11y: true,
      direction: 'horizontal',
      keyboard: true,
      slidesPerView: this.isSmallMobile ? 1 : 4,
      mousewheel: false,
      scrollbar: false,
      navigation: true,
      pagination: false,
      autoplay: {
        delay: 5000,
      },
      fadeEffect: {
        crossFade: true
      },

    };
  }

  ngOnDestroy() {
    this.query.removeEventListener('change', (event: MediaQueryListEvent) => {
      this.isSmallMobile = event.matches;
    });
  }

  observeMediaQuery() {
    const query = this.media.matchMedia('(max-width: 767px)');
    
    this.isSmallMobile = query.matches;

    this.query.addEventListener('change', evt => {
      this.isSmallMobile = evt.matches;
    });
  }

}
